<div class="settings-user-management">
    <div class="settings-user-management-header mb-3">
        <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3">
            <div>
                <div class="d-flex flex-wrap align-items-center gap-2 mb-2">
                    <span class="settings-section-icon">
                        <i class="bi bi-people-fill"></i>
                    </span>
                    <h4 class="text-white fw-bold mb-0">User Management</h4>
                </div>
                <p class="text-white-50 mb-0 text-sm">
                    Add users, update their roles, and manage account access.
                </p>
            </div>

            <div class="settings-user-stats">
                <div class="settings-stat-tile">
                    <span class="settings-stat-value">{{ users.length }}</span>
                    <span class="settings-stat-label">Users</span>
                </div>
                <div class="settings-stat-tile">
                    <span class="settings-stat-value">{{ active_users_count }}</span>
                    <span class="settings-stat-label">Active</span>
                </div>
            </div>

            <button
                type="button"
                class="btn-primary rounded-3 d-flex align-items-center justify-content-center gap-2 settings-add-user-trigger"
                @click="open_add_user"
            >
                <i class="bi bi-person-plus-fill fs-6"></i>
                <span class="text-xs">Add user</span>
            </button>
        </div>
    </div>

    <div v-if="load_error" class="alert alert-danger border-0 rounded-3 mb-3" role="alert">
        {{ load_error }}
    </div>

    <div v-if="save_success" class="alert alert-success border-0 rounded-3 mb-3" role="alert">
        {{ save_success }}
    </div>

    <div class="settings-table-shell settings-reference-table">
        <div v-if="is_loading" class="d-flex align-items-center gap-3 text-white-50 p-3">
            <div class="spinner-border spinner-border-sm text-light" role="status" aria-hidden="true"></div>
            <span class="text-xs">Loading users...</span>
        </div>

        <div v-else-if="!users.length" class="text-center text-white py-4 text-xs">
            <div class="d-flex flex-column align-items-center justify-content-center py-4">
                <span class="settings-empty-icon">
                    <i class="bi bi-people-fill"></i>
                </span>
                <p class="text-white fw-semibold mb-1">No users available</p>
                <p class="text-white text-xs mb-0">Added users will appear here.</p>
            </div>
        </div>

        <div v-else class="table-responsive">
            <table
                class="table align-middle mb-0 settings-data-table global_data_table text-xs"
                data-search-placeholder="Search users"
                data-non-orderable-targets="[4]"
                data-page-length="5"
                data-order-column="0"
                data-order-direction="asc"
            >
                <thead>
                    <tr>
                        <th scope="col" class="settings-table-head text-white fw-semibold text-xs">User</th>
                        <th scope="col" class="settings-table-head text-white fw-semibold text-xs">Email</th>
                        <th scope="col" class="settings-table-head text-white fw-semibold text-xs">Role</th>
                        <th scope="col" class="settings-table-head text-white fw-semibold text-xs">Status</th>
                        <th scope="col" class="settings-table-head text-white fw-semibold text-xs text-end">Actions</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="user in users" :key="user.id">
                        <td>
                            <div class="d-flex align-items-center gap-2">
                                <span class="settings-user-avatar d-inline-flex align-items-center justify-content-center rounded-circle">
                                    {{ get_initials(user) }}
                                </span>
                                <div class="d-flex flex-column gap-1">
                                    <span class="text-white fw-semibold text-xs">{{ get_full_name(user) }}</span>
                                    <span class="settings-muted-cell">{{ user.username || "No username" }}</span>
                                </div>
                            </div>
                        </td>
                        <td class="text-white fw-semibold text-xs">{{ user.email || "-" }}</td>
                        <td>
                            <span class="settings-soft-badge settings-soft-badge-info text-xs">
                                {{ user.role || "-" }}
                            </span>
                        </td>
                        <td>
                            <span
                                class="settings-status-pill text-xs"
                                :class="user.is_active ? 'settings-status-active' : 'settings-status-inactive'"
                            >
                                {{ user.is_active ? "Active" : "Inactive" }}
                            </span>
                        </td>
                        <td>
                            <div class="d-flex justify-content-end gap-2 flex-wrap">
                                <button
                                    type="button"
                                    class="settings-icon-action"
                                    @click="open_edit_user(user)"
                                    aria-label="Edit user"
                                    title="Edit user"
                                >
                                    <i class="bi bi-pencil-square"></i>
                                </button>

                                <button
                                    type="button"
                                    class="settings-action-button"
                                    @click="toggle_user_status(user)"
                                    :disabled="is_saving || (is_current_user(user) && user.is_active)"
                                    :aria-label="user.is_active ? 'Deactivate user' : 'Activate user'"
                                    :title="is_current_user(user) && user.is_active ? 'You cannot deactivate your own account' : ''"
                                >
                                    <span class="text-xs">{{ user.is_active ? "Deactivate" : "Activate" }}</span>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <SettingsAddUserModal
        :is_open="show_add_user_modal"
        :is_saving="is_saving"
        :form_error="form_error"
        :role_options="role_options"
        :is_loading_roles="is_loading_roles"
        @close="close_add_user_modal"
        @submit="add_user"
    />

    <SettingsEditUserModal
        :is_open="show_edit_user_modal"
        :user="selected_user"
        @close="close_edit_user_modal"
        @saved="handle_edit_user_saved"
    />
</div>
